export default {
  title: 'Upload bank statements',
  openBankingNotice: {
    title: "We're sorry, something went wrong.",
    paragraph:
      'On this occasion we have not been able to access your statements from your bank. In order to get an instant decision please follow the instructions below and upload your bank statements.'
  }
};
